import React from 'react'
import { ShippingOptionsTableProps } from './ShippingOptionsTable.types'
import styles from './ShippingOptionsTable.module.scss'
import cl from 'classnames'
import {
  LightTag, SwitchButton, TableBodyContainer,
  TableBodyLine, TableContainer, TableHeader, Text1
} from 'components/shared'
import { formatPrice } from 'utilities'
import { PRODUCT_STORE } from 'store'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import tableBodyContainerStyle from '../../../../components/shared/TableBodyContainer/TableBodyContainer.module.scss'

// const shippingsTableWidths = {
//   name: 17,
//   deliveryTime: 12,
//   price: 20,
//   countries: 45,
//   enable: 6
// }
const shippingsTableWidths = {
  name: 300,
  deliveryTime: 230,
  price: 350,
  countries: 775,
  enable: 100
}

const ShippingOptionsTableComponent = (props: ShippingOptionsTableProps) => {
  const {
    [PRODUCT_STORE]: {
      productShippingIds,
      brandShippings,
      switchShippingEnable
    }
  } = props

  return (
    <TableContainer noBoxShadow style={{ marginTop: 15, overflowX: 'auto' }} className={styles.thinScroll}>
      <TableHeader
        noFilters
        tableColumns={[
          {
            label: 'name',
            // widthPercentage: shippingsTableWidths.name
            widthPx: shippingsTableWidths.name
          },
          {
            label: 'delivery time',
            // widthPercentage: shippingsTableWidths.deliveryTime
            widthPx: shippingsTableWidths.deliveryTime
          },
          {
            label: 'price',
            // widthPercentage: shippingsTableWidths.price
            widthPx: shippingsTableWidths.price
          },
          {
            label: 'countries',
            // widthPercentage: shippingsTableWidths.countries
            widthPx: shippingsTableWidths.countries
          },
          {
            label: 'enable',
            // widthPercentage: shippingsTableWidths.enable
            widthPx: shippingsTableWidths.enable
          }
        ]}
      />

      <TableBodyContainer className={tableBodyContainerStyle.tableBodyContainer}>
        {brandShippings.map(shipping => {
          return (
            <TableBodyLine
              key={shipping.id}
              cells={[
                {
                  // widthPercentage: shippingsTableWidths.name,
                  widthPx: shippingsTableWidths.name,
                  children: <Text1 bold overflowEllipsis>{shipping.name}</Text1>
                },
                {
                  // widthPercentage: shippingsTableWidths.deliveryTime
                  widthPx: shippingsTableWidths.deliveryTime
                },
                {
                  // widthPercentage: shippingsTableWidths.price,
                  widthPx: shippingsTableWidths.price,
                  children: (
                    <div>
                      <Text1 overflowEllipsis>{formatPrice(shipping.price)}</Text1>
                      {shipping.freeAmount && (
                        <Text1 overflowEllipsis>
                          Free shipping above: {formatPrice(shipping.freeAmount)}
                        </Text1>
                      )}
                    </div>
                  )
                },
                {
                  // widthPercentage: shippingsTableWidths.countries,
                  widthPx: shippingsTableWidths.countries,
                  className: cl(styles.countryTags, styles.scrollable),
                  children: (shipping.countries || []).map(country => (
                    <LightTag key={country} text={country} />
                  ))
                },
                {
                  // widthPercentage: shippingsTableWidths.enable,
                  widthPx: shippingsTableWidths.enable,
                  children: (
                    <SwitchButton
                      isOn={productShippingIds.has(shipping.id)}
                      onChange={() => switchShippingEnable(shipping.id)}
                    />
                  )
                }
              ]}
            />
          )
        })}
      </TableBodyContainer>
    </TableContainer>
  )
}

const ShippingOptionsTable = inject(PRODUCT_STORE)(observer(ShippingOptionsTableComponent))
export { ShippingOptionsTable }
